"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfirmPrompt = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const nano_theme_1 = require("nano-theme");
const BasicButton_1 = require("../../2-inline-block/BasicButton");
const WithShortcut_1 = require("../../2-inline-block/WithShortcut");
const MiniTitle_1 = require("../../3-list-item/MiniTitle");
const ContextMenu_1 = require("../ContextMenu");
const containerClass = (0, nano_theme_1.rule)({
    d: 'flex',
    fld: 'column',
    gap: '4px',
    pd: '16px',
    bxz: 'border-box',
    maxW: '90vw',
});
const innerClass = (0, nano_theme_1.rule)({
    d: 'flex',
    fld: 'column',
    gap: '8px',
    pd: '0 16px',
});
const headerClass = (0, nano_theme_1.rule)({
    d: 'flex',
    fld: 'column',
    gap: '4px',
});
const headerTitleClass = (0, nano_theme_1.rule)({
    col: 'var(--colTxtSharp)',
    mr: 0,
    fz: '16px',
    fw: 600,
});
const bodyClass = (0, nano_theme_1.rule)({
    col: 'var(--colTxtLite)',
    fz: '14px',
    lh: 1.5,
    mr: 0,
});
const footerClass = (0, nano_theme_1.rule)({
    d: 'flex',
    ai: 'center',
    jc: 'flex-end',
    gap: '8px',
    mrt: '16px',
});
const ConfirmPrompt = ({ miniTitle, title, children, confirmLabel, cancelLabel = 'Cancel', confirmShortcut = 'Enter', cancelShortcut = 'Esc', confirmProps, cancelProps, positive, onConfirm, onCancel, autoFocus = true, captureKeysGlobally = true, width = 444, }) => {
    const onKeyDown = React.useCallback((event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            event.stopPropagation();
            onConfirm?.();
        }
        else if (event.key === 'Escape') {
            event.preventDefault();
            event.stopPropagation();
            onCancel?.();
        }
    }, [onConfirm, onCancel]);
    const containerRef = React.useRef(null);
    React.useEffect(() => {
        if (!autoFocus)
            return;
        const el = containerRef.current;
        if (!el)
            return;
        const raf = requestAnimationFrame(() => {
            try {
                el.focus({ preventScroll: true });
            }
            catch { }
        });
        return () => cancelAnimationFrame(raf);
    }, [autoFocus]);
    React.useEffect(() => {
        if (!captureKeysGlobally)
            return;
        const onKey = (event) => {
            if (event.key === 'Enter') {
                event.preventDefault();
                event.stopImmediatePropagation();
                onConfirm?.();
            }
            else if (event.key === 'Escape') {
                event.preventDefault();
                event.stopImmediatePropagation();
                onCancel?.();
            }
        };
        window.addEventListener('keydown', onKey, true);
        return () => window.removeEventListener('keydown', onKey, true);
    }, [captureKeysGlobally, onConfirm, onCancel]);
    const cancelBtn = (React.createElement(BasicButton_1.BasicButton, { type: "button", width: "auto", height: 32, border: true, onClick: onCancel, ...cancelProps }, cancelLabel));
    const confirmBtn = (React.createElement(BasicButton_1.BasicButton, { type: "button", width: "auto", height: 32, border: true, positive: positive, ...confirmProps, onClick: onConfirm }, confirmLabel));
    return (React.createElement(ContextMenu_1.ContextPane, null,
        React.createElement("div", { ref: containerRef, className: containerClass, tabIndex: -1, onKeyDown: onKeyDown, style: { outline: 'none', width } },
            miniTitle !== undefined && miniTitle !== null && (React.createElement(MiniTitle_1.MiniTitle, { style: { alignSelf: 'flex-end' } }, miniTitle)),
            React.createElement("div", { className: innerClass },
                React.createElement("div", { className: headerClass },
                    React.createElement("h2", { className: headerTitleClass }, title)),
                children !== undefined && children !== null && React.createElement("p", { className: bodyClass }, children)),
            React.createElement("div", { className: footerClass },
                cancelShortcut == null ? cancelBtn : React.createElement(WithShortcut_1.WithShortcut, { shortcut: cancelShortcut }, cancelBtn),
                confirmShortcut == null ? confirmBtn : React.createElement(WithShortcut_1.WithShortcut, { shortcut: confirmShortcut }, confirmBtn)))));
};
exports.ConfirmPrompt = ConfirmPrompt;
